import { PawPrint } from "lucide-react";
import { Link } from "react-router-dom";
import { useStore } from "../../context/StoreContext";

const LINKS = [
  { to: "/legal/contacto", label: "Contact", id: "contacto" },
  { to: "/legal/envios", label: "Shipping Policy", id: "envios" },
  { to: "/legal/devoluciones", label: "Returns", id: "devoluciones" },
  { to: "/legal/privacidad", label: "Privacy", id: "privacidad" },
  { to: "/legal/cookies", label: "Cookies", id: "cookies" },
  { to: "/legal/terminos", label: "Terms & Conditions", id: "terminos" },
  { to: "/legal/aviso-legal", label: "Legal Notice", id: "aviso-legal" },
];

export const Footer = () => {
  const { config } = useStore();
  return (
    <footer data-testid="footer" className="border-t border-zinc-100 bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-8">
          <div>
            <span className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-full bg-brand flex items-center justify-center">
                <PawPrint className="w-4 h-4 text-white" />
              </span>
              <span className="font-display font-bold text-lg">PeloCero</span>
            </span>
            <p className="mt-3 text-sm text-zinc-500 max-w-xs">
              The reusable, self-cleaning roller for homes with dogs and cats.
            </p>
            <a
              data-testid="footer-contact-email"
              href={`mailto:${config?.contact_email || "hola@pelocero.es"}`}
              className="mt-3 inline-block text-sm font-semibold text-brand hover:text-brand-dark transition-colors"
            >
              {config?.contact_email || "hola@pelocero.es"}
            </a>
          </div>
          <nav className="grid grid-cols-2 gap-x-10 gap-y-3" aria-label="Legal">
            {LINKS.map((l) => (
              <Link
                key={l.id}
                to={l.to}
                data-testid={`footer-link-${l.id}`}
                className="text-sm text-zinc-500 hover:text-ink transition-colors"
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
        <p className="mt-10 pt-6 border-t border-zinc-100 text-xs text-zinc-400">
          © {new Date().getFullYear()} PeloCero. All rights reserved. Prices in USD.
        </p>
      </div>
    </footer>
  );
};
